import React from "react";

import { Text } from "react-native"
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import loadable from "@loadable/component";

import { navigationRef } from './RootNavigation';
import store from "./store";
import { Provider } from 'react-redux'
import { MediaProvider } from "./media/MediaProvider";
import ErrorBoundary from './components/ErrorBoundary';

const Main = loadable(() => import('./pages/Main'))
const NotFound = loadable(() => import('./pages/NotFound'))
const PdfOnFlyScreen = loadable(() => import('./pages/PdfOnFlyScreen'))
const PdfJustDownload = loadable(() => import('./pages/PdfJustDownload'))
const Details = loadable(() => import('./pages/Details'))


const Stack = createStackNavigator();
const config = {
  screens: {
    Home: '/listing/:lang/:key',
    Details: '/listing/:lang/:key/:token/:slug',
    Pdf: '/listing/:lang/:key/:token/:slug/pdf',
    Download: '/listing/:lang/:key/:token/:slug/download',
  },
};

const linking = {
  prefixes: ['http://localhost:9292', 'https://api.topbroker.lt', 'tbproposal://'],
  config,
};




function App() {

  return (
    <React.StrictMode>
		<Provider store={store}>
      <MediaProvider>
      <ErrorBoundary fullPage>
      <NavigationContainer ref={navigationRef} linking={linking} fallback={<Text>Loading...</Text>}>
        <Stack.Navigator headerMode="screen" screenOptions={{presentation: 'card'}} >
            <Stack.Screen name="404" options={{headerShown: false}} component={NotFound}  />
            <Stack.Screen name="Home" options={{headerShown: false}} component={Main} />
            <Stack.Screen name="Details" options={{headerShown: false}} component={Details} />
            <Stack.Screen name="Pdf" options={{headerShown: false}} component={PdfOnFlyScreen} />
            <Stack.Screen name="Download" options={{headerShown: false}} component={PdfJustDownload} />
        </Stack.Navigator>
			</NavigationContainer>
      </ErrorBoundary>
      </MediaProvider>
      </Provider>
    </React.StrictMode>
  );
}
export default App;
